<template>
  <div>
    <d-list-group flush @keyup.enter="submitForm">
        <div
            v-if="isValuesSetup"
            class="overlay-loading">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <d-card-header class="border-bottom flex-header">
            <h6 class="m-0">
                Nowa umowa
                <span v-if="isContractInternal"> wewnętrzna </span>
            </h6>
            <d-button theme="primary"  @click.prevent="submitDraft"><i class="material-icons">save</i> Zapisz jako szkic</d-button>
            <d-button theme="primary" @click.prevent="activeTab--" :class="{ disabled: activeTab === 0 }"><i class="material-icons">navigate_before</i> Poprzedni krok</d-button>
            <d-button theme="success" @click.prevent="nextStep(activeTab)" v-if="activeTab < 2">Następny krok <i class="material-icons">navigate_next</i></d-button>
            <d-button theme="success" v-if="activeTab >= 2 && getUser.is_admin === 1" @click.prevent="submitForm"><i class="material-icons">add</i> Dodaj umowę</d-button>
        </d-card-header>

        <ul class="ss-progress-nav">
            <li class="active">
                <span>1</span>
                <span>Dane podstawowe</span>
            </li>
            <li :class="{ active: activeTab >= 1}">
                <span>2</span>
                <span v-if="isContractInternal">Dokumenty</span>
                <span v-else>Poręczyciele, zabezpieczenia i&nbsp;dokumenty</span>
            </li>
            <li :class="{ active: activeTab >= 2}">
                <span>3</span>
                <span>Harmonogram</span>
            </li>
        </ul>
        <ul class="ss-tabs">
            <li :class="{ active: activeTab === 0}">
                <d-card-header class="border-bottom">
                    <h6 class="m-0">Dane podstawowe</h6>
                </d-card-header>
                <d-list-group-item class="p-3">
                    <d-form>
                        <d-form-row>
                          <d-col md="6" class="form-group">
                            <label class="w-100">Uwzględnij VAT</label>
                            <d-checkbox inline v-model="vatIncluded" toggle />
                          </d-col>
                          <d-col md="6" class="form-group">
                            <label>Kolejność zaliczania wpłat</label>
                            <d-select
                              name="payment_allocation"
                              v-model="schedule.payment_allocation">
                              <option value="capital_first">Najpierw kapitał</option>
                              <option value="interest_first">Najpierw koszty i odsetki</option>
                            </d-select>
                          </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label>Data umowy</label>
                                <ss-date type="text"
                                         name="contract_date"
                                         v-model="schedule.contract_date"
                                         @click="lar_errors.clear('contract_date')"
                                         :class="{'is-invalid' : lar_errors.has('contract_date')}"
                                         placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('contract_date')"></div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="schedule.contract_number" name="contract_number" label="Nr umowy" placeholder="Nr umowy"></ss-input>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label>Kwota pożyczki (w tym prowizja)</label>
                                <ss-price-input type="text"
                                                name="loan_amount_with_commission"
                                                v-model="loanAmountWithCommission"
                                                @input="lar_errors.clear('loan_amount')"
                                                :class="{'is-invalid' : lar_errors.has('loan_amount')}"
                                                placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('loan_amount')"></div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <label>Kwota pożyczki dla klienta</label>
                                <ss-price-input type="text"
                                                name="loan_amount"
                                                v-model="schedule.loan_amount"
                                                :disabled="true"
                                                placeholder=""/>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label>Spółka</label>
                                <d-select type="text"
                                          name="company_id"
                                          v-model="schedule.company_id"
                                          @input="lar_errors.clear('company_id')"
                                          :class="{'is-invalid' : lar_errors.has('company_id')}"
                                          placeholder="">
                                    <option :value="null">--Wybierz spółkę</option>
                                    <option :value="company.id" v-for="company in allCompanies" :key="company.id">
                                        {{ company.name }}
                                    </option>
                                </d-select>
                                <div class="invalid-feedback" v-text="lar_errors.get('company_id')"></div>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label>Odsetki (%)</label>
                                <ss-price-input type="text"
                                                name="loan_installment"
                                                v-model="schedule.interest_rate"
                                                @blur="calculateCapitals"
                                                @input="lar_errors.clear('interest_rate')"
                                                :class="{'is-invalid' : lar_errors.has('interest_rate')}"
                                                placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('interest_rate')"></div>
                            </d-col>
                            <d-col
                              v-if="schedule.include_vat === 0"
                              md="6"
                              class="form-group">
                                <label>Prowizja (zł)</label>
                                <ss-price-input v-model="schedule.installment_sum" />
                            </d-col>
                        </d-form-row>
                        <d-form-row v-if="schedule.include_vat === 1">
                            <d-col md="6" class="form-group">
                                <label>Prowizja netto (zł)</label>
                                <ss-price-input
                                  v-model="installment_sum_net"
                                  @input="setGrossForValue(installment_sum_net, 'schedule.installment_sum', 'installment_sum', 'input')"
                                  :disabled="isValuesSetup || isCalculatingGross || isCalculatingNet"
                                  :class="{'is-invalid' : lar_errors.has('installment_sum_net')}" />
                                <div
                                  class="invalid-feedback"
                                  v-text="lar_errors.get('installment_sum_net')">
                                </div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <label>Prowizja brutto (zł)</label>
                                <ss-price-input
                                  v-model="schedule.installment_sum"
                                  :disabled="isValuesSetup || isCalculatingGross || isCalculatingNet"
                                  @input="setNetForValue(schedule.installment_sum, 'installment_sum_net', 'installment_sum_net', 'input')" />
                            </d-col>
                          </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label for="number_of_installments">Liczba rat</label>
                                <input class="form-control" id="number_of_installments"
                                       type="text"
                                       @blur="rearrangeInstallments"
                                       name="number_of_installments"
                                       v-model="schedule.number_of_installments"
                                       @input="lar_errors.clear('number_of_installments')"
                                       :class="{'is-invalid' : lar_errors.has('number_of_installments')}"
                                       placeholder="" />
                                <div class="invalid-feedback" v-text="lar_errors.get('number_of_installments')"></div>
                                <d-button class="m-top" @click.prevent="optimalInstallmentsNumber">Optymalna liczba rat</d-button>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <label>Kwota raty</label>
                                <ss-price-input type="text"
                                                name="installment_fee"
                                                v-model="schedule.installment_fee"
                                                @change="lar_errors.clear('installment_fee')"
                                                :class="{'is-invalid' : lar_errors.has('installment_fee')}"
                                                @input="generateTable"
                                                placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('installment_fee')"></div>
                                <d-button class="m-top" @click.prevent="optimalInstallmentFee">Optymalna kwota raty</d-button>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label>Data pierwszej raty</label>
                                <ss-date type="text"
                                         name="first_installment_date"
                                         v-model="schedule.first_installment_date"
                                         @click="lar_errors.clear('first_installment_date')"
                                         :class="{'is-invalid' : lar_errors.has('first_installment_date')}"
                                         placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('first_installment_date')"></div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <label>Częstotliwość rat</label>
                                <d-select type="text"
                                          name="installment_frequency"
                                          v-model="schedule.installment_frequency"
                                          @input="lar_errors.clear('installment_frequency')"
                                          :class="{'is-invalid' : lar_errors.has('installment_frequency')}"
                                          placeholder="">
                                    <option :value="period.id" v-for="period in installment_frequency_periods" :key="period.id">
                                        {{ period.name }}
                                    </option>
                                </d-select>
                                <div class="invalid-feedback" v-text="lar_errors.get('installment_frequency')"></div>
                            </d-col>
                        </d-form-row>

                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <label>Kwota z oświadczenia o poddaniu się egzekucji</label>
                                <ss-price-input type="text"
                                                name="contract_statement_amount"
                                                v-model="schedule.contract_statement_amount"
                                                @input="lar_errors.clear('contract_statement_amount')"
                                                :class="{'is-invalid' : lar_errors.has('contract_statement_amount')}"
                                                placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('contract_statement_amount')"></div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <label>Data oświadczenia o poddaniu się egzekucji</label>
                                <ss-date type="text"
                                         name="contract_statement_date"
                                         v-model="schedule.contract_statement_date"
                                         @click="lar_errors.clear('contract_statement_date')"
                                         :class="{'is-invalid' : lar_errors.has('contract_statement_date')}"
                                         placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('contract_statement_date')"></div>
                            </d-col>
                        </d-form-row>
                        <d-form-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="schedule.contract_statement_doc" name="contract_statement_doc" label="Nr Rep. A" placeholder="Nr aktu notarialnego"></ss-input>
                            </d-col>
                            <d-col
                              v-if="schedule.include_vat === 0"
                              md="6"
                              class="form-group">
                                <label>Koszty monitów</label>

                                <ss-price-input type="text"
                                                name="default_reminder_price"
                                                v-model="schedule.default_reminder_price"
                                                @input="lar_errors.clear('default_reminder_price')"
                                                :class="{'is-invalid' : lar_errors.has('default_reminder_price')}"
                                                placeholder=""/>
                                <div class="invalid-feedback" v-text="lar_errors.get('default_reminder_price')"></div>
                            </d-col>
                        </d-form-row>
                        <d-form-row v-if="schedule.include_vat === 1">
                            <d-col md="6" class="form-group">
                                <label>Koszty monitów netto</label>
                                <ss-price-input
                                  v-model="default_reminder_price_net"
                                  @input="setGrossForValue(default_reminder_price_net, 'schedule.default_reminder_price', 'default_reminder_price_net', 'input')"
                                  :class="{'is-invalid' : lar_errors.has('default_reminder_price_net')}" />
                                <div
                                  class="invalid-feedback"
                                  v-text="lar_errors.get('default_reminder_price')">
                                </div>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <label>Koszty monitów brutto</label>
                                <ss-price-input
                                  v-model="schedule.default_reminder_price"
                                  :disabled="true" />
                            </d-col>
                        </d-form-row>

                        <div class="form-group">
                            <ss-textarea name="loan_purpose" v-model="schedule.loan_purpose" label="Cel pożyczki" placeholder="Opis..."></ss-textarea>
                        </div>

                        <contract-conditions-list
                            :schedule-conditions="schedule.conditions"
                            @conditions-changed="handleConditionsChanged"
                        />

                        <div class="card-body p-0 pb-3 text-center">
                            <table class="table mt-2 mb-0" style="border: 1px #dee2e6 solid;table-layout: fixed;">
                                <thead class="bg-light">
                                <tr>
                                    <th scope="col" class="border-0">Kwota pożyczki (w tym prowizja)</th>
                                    <th scope="col" class="border-0">Prowizja</th>
                                    <th scope="col" class="border-0">Kwota pożyczki dla klienta</th>
                                    <th scope="col" class="border-0">Odsetki</th>
                                    <th scope="col" class="border-0">Kwota końcowa</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{{ toNumber(capitalSum) }} zł</td>
                                    <td>{{ toNumber(schedule.installment_sum) }} zł</td>
                                    <td>{{ toNumber(schedule.loan_amount) }} zł</td>
                                    <td>{{ toNumber(interestSum) }} zł</td>
                                    <td>{{ toNumber(capitalSum + penaltySum + interestSum) }} zł</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <ss-textarea v-model="schedule.comments"
                                     name="comments"
                                     label="Komentarze"
                                     placeholder="Opis..."></ss-textarea>
                    </d-form>
                </d-list-group-item>
            </li>
            <li :class="{ active: activeTab === 1}">
                <template v-if="!isContractInternal">
                    <contract-guarantors
                        ref="new-contract-guarantors"
                        :guarantors-list="guarantors_list"
                        :is-contract-add="true"
                        :is-draft="false"
                        :schedule-guarantors-list="schedule.guarantors"
                        :client-id="clientId" />

                    <contract-guarantees
                        ref="contract-guarantees"
                        :client-id="clientId"
                        :guarantees="guarantees"
                        :guarantees-default="[]"
                        :is-contract-add="true"
                        :is-draft="false"
                        :schedule="schedule"
                        :schedule-guarantees="guarantees"/>
                </template>

                <d-card-header class="border-bottom flex-header">
                    <h6 class="m-0">Wybierz dokumenty</h6>
                    <d-button
                        @click.prevent="addNewDocument"
                        theme="primary">
                        <i class="material-icons">add</i> Dodaj nowy dokument
                    </d-button>
                </d-card-header>
                <d-list-group-item>
                    <contract-docs-list
                        v-if="documents"
                        :documents-edit="true"
                        :is-draft="false"
                        :schedule-documents="documents"
                        :schedule="schedule" />
                </d-list-group-item>
            </li>
            <li :class="{ active: activeTab === 2}">
                <d-card-header class="border-bottom">
                    <h6 class="m-0">Harmonogram rat</h6>
                </d-card-header>
                <d-list-group-item class="text-center">
                    <table class="table mb-0 responsive-table" style="border: 1px #dee2e6 solid;table-layout: fixed;">
                        <thead class="bg-light">
                        <tr>
                            <th scope="col" class="border-0 col-id">#</th>
                            <th scope="col" class="border-0">Data płatności</th>
                            <th scope="col" class="border-0">Rata</th>
                            <th scope="col" class="border-0">Kapitał</th>
                            <th scope="col" class="border-0">Odsetki</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :class="[
                            { red : rowThemeDanger(installment) },
                            { green : rowThemeSuccess(installment) },
                            { disabled : !rowThemeSuccess(installment) && schedule.is_terminated === 1 },
                            ]" v-for="(installment, index) in schedule.installments"
                            :key="index"
                        >
                            <td>
                                <dt>#</dt>
                                <dd>{{ (parseInt(index) + 1) }}</dd>
                            </td>
                            <td>
                                <dt>Data płatności</dt>
                                <dd>
                                    <ss-date type="text"
                                             name="payment_date"
                                             v-model="installment.payment_date"
                                             @click="lar_errors.clear('payment_date')"
                                             :limitfrom="getLimitFrom(index)"
                                             :limitto="getLimitTo(index)"
                                             :class="{'is-invalid' : lar_errors.has('payment_date')}"
                                             placeholder=""/>
                                </dd>
                            </td>
                            <td>
                                <dt>Rata</dt>
                                <dd>
                                    <ss-price-input v-if="index < schedule.installments.length -1"
                                                    type="text"
                                                    name="installment_fee"
                                                    v-model="installment.installment_fee"
                                                    @input="singleInstallmentChanged" />
                                    <ss-price-input v-else
                                                    :readonly="true"
                                                    type="text"
                                                    name="installment_fee"
                                                    :value="lastInstallment" />
                                </dd>
                            </td>
                            <td>
                                <dt>Kapitał</dt>
                                <dd>{{ toNumber(installment.capital) }} zł</dd>
                            </td>
                            <td :class="{ 'is-loading': interests_loading }">
                                <dt>Odsetki</dt>
                                <dd>{{ toNumber(installment.interest) }} zł</dd>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </d-list-group-item>
            </li>
        </ul>
    </d-list-group>

    <document-form-modal
        :is-modal-visible="isDocumentModalVisible"
        :selected-document="selectedDocument" />
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import CommonUtils from '@/utils/CommonUtils';
import LarErrors from '../../helpers/Errors';
import SsDate from '../common/SsDate';
import SsTextarea from '../common/SsTextarea';
import SsPriceInput from '../common/SsPriceInput';
import clientUtils from '../../utils/client';
import { capitalParts } from '@/utils/scheduleCapitals';
import { mapGetters, mapActions } from 'vuex';
import ContractGuarantees from '@/components/client/contract-partials/guarantees/ContractGuarantees.vue';
import ContractGuarantors from '@/components/client/contract-partials/guarantors/ContractGuarantors';
import ContractDocsList from '@/components/client/contract-partials/docs/ContractDocsList.vue';
import DocumentFormModal from '@/components/client/contract-partials/docs/DocumentFormModal.vue';
import ContractConditionsList from '@/components/client/contract-partials/conditions/ContractConditionsList.vue';

export default {
  name: 'ContractNew',
  components: {
    SsDate,
    SsPriceInput,
    SsTextarea,
    LarErrors,
    ContractGuarantees,
    ContractGuarantors,
    ContractDocsList,
    DocumentFormModal,
    ContractConditionsList,
  },
  props: {
    save: {
      type: Boolean,
      default: false,
    },
    guarantors: {
      type: Array,
      default: () => {},
    },
    guarantees: {
      type: Array,
      default: () => {},
    },
    documents: {
      type: Array,
      default: () => {},
    },
    isContractInternal: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      activeTab: 0,
      default_reminder_price_net: 0,
      fetched: false,
      guarantor: {},
      guarantors_list: [],
      installment_frequency_periods: clientUtils._installment_frequency_periods,
      installment_sum_net: 0,
      interests_loading: false,
      isCalculatingGross: false,
      isCalculatingNet: false,
      isDocumentModalVisible: false,
      isValuesSetup: false,
      lar_errors: LarErrors,
      save_form: false,
      schedule: _.clone(clientUtils._schedule),
      selectedDocument: null,
      submitting: false,
      vatIncluded: false,
    };
  },
  computed: {
    loanAmountWithCommission: {
      get() {
        return parseFloat(this.schedule.loan_amount || 0) + parseFloat(this.schedule.installment_sum || 0);
      },
      set(value) {
        this.schedule.loan_amount = parseFloat(value || 0) - parseFloat(this.schedule.installment_sum || 0);
      },
    },
    lastInstallment() {
      return this.schedule.installments[this.schedule.installments.length - 1].installment_fee +
                    this.interestSum + this.penaltySum;
    },
    capitalSum() {
      return this.loanAmountWithCommission;
    },
    firstPaymentDate() {
      return new Date(this.schedule.first_installment_date);
    },
    penaltySum() {
      return this.schedule.installments.reduce((total, installment) => {
        total += installment.interest_penalty;
        return total;
      }, 0);
    },
    interestSum() {
      return this.schedule.installments.reduce((total, installment) => {
        total += installment.interest;
        return total;
      }, 0);
    },
    ...mapGetters([
      'allCompanies',
      'getUser',
    ]),
    installmentsTrigger() {
      return `${this.schedule.interest_rate}=${this.schedule.installments.map(installment => [installment.installment_fee, installment.payment_date, installment.capital].join('-')).join(';')}`;
    },
  },
  methods: {
    ...mapActions([
      'getAllCompanies',
    ]),
    async setGrossForValue (value, fieldPath, errorFieldName, callbackSource) {
      if (this.isValuesSetup && callbackSource === 'input') {
        return;
      }

      if (callbackSource === 'input' && (this.isCalculatingNet || this.isCalculatingGross)) {
        return;
      }

      this.isCalculatingGross = true;

      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        this.$nextTick(function () {
          this.isCalculatingGross = false;
        });
        return;
      }

      let { value: grossValue, isError} = await FormUtils.getGrossValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = ['Błąd obliczenia wartości'];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          this.$nextTick(function () {
            this.isCalculatingGross = false;
          });
          return;
        } else {
          this.lar_errors.clear(errorFieldName);
        }
      }

      CommonUtils.setValueInPath(this, fieldPath, grossValue);
      this.$nextTick(function () {
        this.isCalculatingGross = false;
      });
    },
    async setNetForValue (value, fieldPath, errorFieldName, callbackSource) {
      if (this.isValuesSetup && callbackSource === 'input') {
        return;
      }

      if (callbackSource === 'input' && (this.isCalculatingNet || this.isCalculatingGross)) {
        return;
      }

      this.isCalculatingNet = true;

      if (!value) {
        this.lar_errors.clear(errorFieldName);
        CommonUtils.setValueInPath(this, fieldPath, 0);
        this.$nextTick(function () {
          this.isCalculatingNet = false;
        });
        return;
      }

      let { value: grossValue, isError} = await FormUtils.getNetValue(value);

      if (errorFieldName) {
        if (isError) {
          this.lar_errors.errors[errorFieldName] = ['Błąd obliczenia wartości'];
          CommonUtils.setValueInPath(this, fieldPath, 0);
          this.$nextTick(function () {
            this.isCalculatingNet = false;
          });
          return;
        } else {
          this.lar_errors.clear(errorFieldName);
        }
      }

      CommonUtils.setValueInPath(this, fieldPath, grossValue);
      this.$nextTick(function () {
        this.isCalculatingNet = false;
      });
    },
    nextStep(step) {
      const _errors = {};
      let _count = 0;

      if (step === 0 && !this.schedule.company_id) {
        _count++;
        _errors.company_id = ['Pole Spółka jest wymagane.'];
      }
      if (step === 0 && !this.schedule.contract_date) {
        _count++;
        _errors.contract_date = ['Pole Data umowy jest wymagane.'];
      }
      if (step === 0 && !this.schedule.contract_number) {
        _count++;
        _errors.contract_number = ['Pole Nr umowy jest wymagane.'];
      }
      if (_count === 0) {
        this.activeTab++;
      } else {
        this.lar_errors.record(_errors);
      }
    },
    toNumber(number) {
      return Vue.toNumber(number);
    },
    rowThemeDanger(inst) {
      return inst.capital < 0 || (inst.capital === 0 && inst.installment_fee === 0);
    },
    rowThemeSuccess(inst) {
      return inst.is_paid === 1;
    },
    optimalInstallmentsNumber() {
      this.schedule.number_of_installments = Math.floor(this.capitalSum / this.schedule.installment_fee);
      this.rearrangeInstallments(this.schedule.number_of_installments);
      this.calculateCapitals();
      this.getInterests();
    },
    optimalInstallmentFee() {
      this.schedule.installment_fee = Math.floor(this.capitalSum / this.schedule.number_of_installments);
      this.$forceUpdate();
      this.calculateCapitals();
    },
    singleInstallmentChanged() {
      this.calculateCapitals();
    },
    submitForm() {
      if (this.schedule.installments[this.schedule.installments.length - 1].capital < 0) {
        Vue.swal({
          type: 'warning',
          title: 'Kapitał rat nie może być ujemny.',
          showConfirmButton: true,
        });
      } else {
        this.submitting = true;
        this.schedule.interest_penalty_sum = this.penaltySum;
        this.schedule.interest_sum = this.interestSum;
        this.schedule.loan_installment_sum = this.capitalSum;
        this.schedule.loan_final_sum = this.capitalSum + this.interestSum + this.penaltySum;
        this.schedule.draft = 0;

        this.schedule.guarantors = [];
        this.schedule.payment_guarantees = [];

        if (this.$refs['new-contract-guarantors']) {
          this.schedule.guarantors = this.$refs['new-contract-guarantors'].selectedGuarantorsFormatted;
        }

        if (!this.isContractInternal && this.$refs['contract-guarantees']) {
          this.schedule.payment_guarantees = this.$refs['contract-guarantees'].selectedGuaranteesFormatted;
        }

        FormUtils.submit(this, {
          endpoint: '/api/schedules/save-schedule',
          formData: this.schedule,
          successTitle: 'Umowa została dodana.',
          successText: '',
          errorTitle: 'Wystąpił błąd',
          errorText: 'Dodawanie umowy nie powiodło się. Spróbuj ponownie.',
          successAction: (response) => {
            this.$emit('contractSaved');
            this.schedule = _.clone(clientUtils._schedule);
            this.schedule.client_id = this.$route.params.id;
            this.$emit('update:save', false);
          },
          failAction: (error) => {
            this.submitting = false;
            LarErrors.record(error.response.data.errors);
            this.$emit('update:save', false);
          },
        });
      }
    },
    submitDraft() {
      if (this.schedule.installments[this.schedule.installments.length - 1].capital < 0) {
        Vue.swal({
          type: 'warning',
          title: 'Kapitał rat nie może być ujemny.',
          showConfirmButton: true,
        });
      } else {
        this.submitting = true;
        this.schedule.draft = 1;
        this.schedule.interest_penalty_sum = this.penaltySum;
        this.schedule.interest_sum = this.interestSum;
        this.schedule.loan_installment_sum = this.capitalSum;
        this.schedule.loan_final_sum = this.capitalSum + this.interestSum + this.penaltySum;

        this.schedule.guarantors = [];
        this.schedule.payment_guarantees = [];

        if (this.$refs['new-contract-guarantors']) {
          this.schedule.guarantors = this.$refs['new-contract-guarantors'].selectedGuarantorsFormatted;
        }

        if (!this.isContractInternal && this.$refs['contract-guarantees']) {
          this.schedule.payment_guarantees = this.$refs['contract-guarantees'].selectedGuaranteesFormatted;
        }

        axios.post('api/schedules/save-schedule', this.schedule).then((response) => {
          this.submitting = false;
          Vue.swal({
            type: 'success',
            title: 'Szkic został dodany.',
            showConfirmButton: true,
          }).then(() => {
            this.$emit('contractSaved');
            this.schedule = _.clone(clientUtils._schedule);
            this.schedule.client_id = this.$route.params.id;
            this.$emit('update:save', false);
          });
        }).catch((error) => {
          Vue.swal({
            type: 'error',
            title: error.response.data.message,
            html: Vue.transformErrorsToHtml(error.response.data.errors),
            showConfirmButton: true,
          });
          this.submitting = false;
          LarErrors.record(error.response.data.errors);
          this.$emit('update:save', false);
        });
      }
    },
    nextWeekDate(i) {
      const nextWeek = new Date(
        this.firstPaymentDate.getFullYear(),
        this.firstPaymentDate.getMonth(),
        this.firstPaymentDate.getDate() + 7 * i,
      );
      return this.dateFormat(nextWeek);
    },
    nextMonthDate(i) {
      const nextWeek = new Date(
        this.firstPaymentDate.getFullYear(),
        this.firstPaymentDate.getMonth() + i,
        this.firstPaymentDate.getDate(),
      );
      return this.dateFormat(nextWeek);
    },
    nextDate(i) {
      switch (this.schedule.installment_frequency) {
        case 1:
          return this.nextWeekDate(i * 2);
          break;
        case 2:
          return this.nextMonthDate(i);
          break;
        case 3:
          return this.nextMonthDate(i * 2);
          break;
        case 4:
          return this.nextMonthDate(i * 3);
          break;
        case 5:
          return this.nextWeekDate(i);
          break;
      }
    },
    dateFormat(d) {
      const dy = d.getFullYear();
      const dm = (d.getMonth() + 1) < 10 ? `0${d.getMonth() + 1}` : (d.getMonth() + 1);
      const dd = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();

      return `${dy}-${dm}-${dd}`;
    },
    calculateCapitals() {
      const capital = parseFloat(this.capitalSum);
      let sum = 0;
      const installments = _.clone(this.schedule.installments);
      // interest_first: z raty schodzi na kapitał tylko część ponad odsetki okresu
      const parts = capitalParts(installments, this.schedule.payment_allocation);
      for (let i = 0; installments.length > i; i++) {
        installments[i].capital = capital - sum;

        if (i === this.schedule.number_of_installments - 1) {
          installments[i].installment_fee = capital - sum;
        }
        sum += parts[i];
      }
      this.schedule.installments = installments;
      this.$forceUpdate();
    },
    generateTable() {
      this.schedule.installments = [];
      for (let i = 0; i < this.schedule.number_of_installments; i++) {
        this.schedule.installments.push({
          installment_fee: this.schedule.installment_fee,
          interest_penalty: 0,
          payment_date: this.nextDate(i),
        });
      }

      this.calculateCapitals();
      this.$forceUpdate();
    },
    generatePaymentDates() {
      for (let i = 0; i < this.schedule.number_of_installments; i++) {
        if (!this.schedule.installments[i]) return false;
        this.schedule.installments[i].payment_date = this.nextDate(i);
      }
    },
    getLimitFrom(index) {
      return index < 2 ? this.schedule.first_installment_date : this.schedule.installments[(index - 1)].payment_date;
    },
    getLimitTo(index) {
      return index < (this.schedule.installments.length - 1) ? this.schedule.installments[(index + 1)].payment_date : '';
    },
    rearrangeInstallments(event) {
      const to = event.target ? event.target.value : event;
      this.schedule.installments = [];
      const installments = [];
      for (let i = 0; i < to; i++) {
        installments.push({
          interest_penalty: 0,
          installment_fee: this.schedule.installment_fee,
          payment_date: '',
        });
      }
      this.schedule.installments = installments;
      this.$forceUpdate();
      this.generatePaymentDates();

      this.$nextTick(function () {
        this.calculateCapitals();
      });
    },
    rowThemeDanger(inst) {
      return inst.capital < 0 || (inst.capital === 0 && inst.installment_fee === 0);
    },
    getInterests: _.debounce(function () {
      this.interests_loading = true;

      const data = {
        installments: this.schedule.installments.map(installment => ({
          installment_fee: installment.installment_fee,
          payment_date: installment.payment_date,
          capital: installment.capital,
        })),
        interest_rate: this.schedule.interest_rate,
        contract_date: this.schedule.contract_date,
        include_vat: this.schedule.include_vat,
        payment_allocation: this.schedule.payment_allocation,
      };

      axios.post('api/calculation/get-interests', data).then((response) => {
        for (let i = 0; i < response.data.installments.length; i++) {
          this.schedule.installments[i].interest = response.data.installments[i].interest;
        }

        this.interests_loading = false;
        this.calculateCapitals();
      }).catch((error) => {
        this.interests_loading = false;
        console.log(error);
        LarErrors.record(error.response.data.errors);
      });
    }, 500),
    handleConditionsChanged(conditions) {
      // Backend oczekuje 'conditions' w request
      this.schedule.conditions = conditions;
    },
    reloadGuarantors() {
      // Reload guarantors list after adding a new one
      axios.post('api/guarantors/get-guarantors', { client_id: this.clientId }).then((response) => {
        if (response.data.guarantors) {
          this.guarantors_list = response.data.guarantors.map((guarantor) => {
            guarantor.declaration_amount = '';
            guarantor.declaration_date = '';
            guarantor.declaration_doc = null;
            return guarantor;
          });
        }
      }).catch((error) => {
        console.error('Error reloading guarantors:', error);
      });
    },
    reloadGuarantees() {
      // Reload guarantees list after adding a new one
      axios.post('api/payment-guarantees/get-payment-guarantees', { client_id: this.clientId }).then((response) => {
        if (response.data.payment_guarantees) {
          this.guarantees = response.data.payment_guarantees;
        }
      }).catch((error) => {
        console.error('Error reloading guarantees:', error);
      });
    },
    addNewDocument() {
      const newDocument = _.clone(clientUtils._document);
      newDocument.client_id = this.clientId;
      this.selectedDocument = newDocument;
      this.isDocumentModalVisible = true;
    },
    closeDocumentModal() {
      this.isDocumentModalVisible = false;
    },
    reloadDocuments(isNew = false) {
      axios.post('api/clients/get-documents', { client_id: this.clientId }).then((response) => {
        if (response.data.documents) {
          this.documents = response.data.documents;

          // Automatycznie dodaj nowy dokument do umowy
          if (isNew && this.documents.length > 0) {
            const newDoc = this.documents[this.documents.length - 1];
            if (!this.schedule.documents.includes(newDoc.id)) {
              this.schedule.documents.push(newDoc.id);
            }
          }
        }
      }).catch((error) => {
        console.error('Error reloading documents:', error);
      });
    },
  },
  mounted() {
    if (this.schedule.default_reminder_price === 0) {
      this.schedule.default_reminder_price = 100;
    }

    this.schedule.contract_date = Vue.getCurrentDate();
    this.schedule.client_id = this.$route.params.id;
    this.schedule.case_is_explained = this.schedule.case_is_explained.toString();
    this.vatIncluded = this.schedule.include_vat === 0 ? false : true;
    this.generateTable();
    this.fetched = true;
    this.save_form = this.save;
    this.optimalInstallmentFee();
    this.getAllCompanies();

    if (this.guarantors) {
      this.guarantors_list = this.guarantors.map((guarantor) => {
        guarantor.declaration_amount = '';
        guarantor.declaration_date = '';
        guarantor.declaration_doc = null;
        return guarantor;
      }, []);
    }

    this.$bus.$on('contract-reload-guarantors', this.reloadGuarantors);
    this.$bus.$on('client-reload-gurantees', this.reloadGuarantees);
    this.$bus.$on('contract-reload-documents', this.reloadDocuments);
    this.$bus.$on('document-form-modal-close', this.closeDocumentModal);

    setTimeout(() => {
      this.calculateCapitals();
    }, 100);
  },
  beforeDestroy() {
    this.$bus.$off('contract-reload-guarantors', this.reloadGuarantors);
    this.$bus.$off('client-reload-gurantees', this.reloadGuarantees);
    this.$bus.$off('contract-reload-documents', this.reloadDocuments);
    this.$bus.$off('document-form-modal-close', this.closeDocumentModal);
  },
  watch: {
    'schedule.interest_rate': function () {
      this.calculateCapitals();
    },
    'schedule.payment_allocation': function () {
      this.calculateCapitals();
      this.getInterests();
    },
    'schedule.loan_amount': function () {
      this.optimalInstallmentFee();
      this.calculateCapitals();
    },
    'schedule.installment_sum': function () {
      this.calculateCapitals();
    },
    'schedule.installment_frequency': function () {
      this.generatePaymentDates();
    },
    'schedule.first_installment_date': function () {
      this.generatePaymentDates();
    },
    save_form(to) {
      if (to) {
        this.submitForm();
        this.save_form = false;
        this.$emit('update:save', this.save_form);
      }
    },
    save(to) {
      this.save_form = to;
    },
    installmentsTrigger(newValue) {
      this.getInterests();
    },
    'schedule.contract_date': function (to) {
      const date = new Date(to);
      const nextMonth = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
      );
      this.schedule.first_installment_date = this.dateFormat(nextMonth);
      this.getInterests();
    },
    scheduleSum(to) {
      this.schedule.interest_sum = to;
    },
    capitalSum(to) {
      this.schedule.loan_installment_sum = to;
    },
    async vatIncluded (newValue) {
      this.schedule.include_vat = newValue ? 1 : 0;

      if (!this.fetched) {
        return;
      }

      if (newValue) {
        Vue.set(this, 'isValuesSetup', true);
        // only installment_sum_net should be based on schedule.installment_sum
        Vue.set(this, 'installment_sum_net', this.schedule.installment_sum);
        await this.setGrossForValue(this.installment_sum_net, 'schedule.installment_sum', 'installment_sum');
        Vue.set(this, 'default_reminder_price_net', this.schedule.default_reminder_price);
        await this.setGrossForValue(this.default_reminder_price_net, 'schedule.default_reminder_price', 'default_reminder_price');

        await this.$nextTick()
        Vue.set(this, 'isValuesSetup', false);
      } else {
        // when switch to contract without VAT installment_sum should be set to installment_sum_net
        Vue.set(this.schedule, 'installment_sum', this.installment_sum_net);
        Vue.set(this.schedule, 'default_reminder_price', this.default_reminder_price_net);
      }
      this.getInterests();
      this.calculateCapitals();
    }
  },
};
</script>

<style lang="scss" scoped>
    ul.ss-progress-nav {
        display: flex;
        width: 100%;
        max-width: 900px;
        margin: 30px auto 0;
        justify-content: space-evenly;
        padding: 0;
        list-style: none;

        li {
            flex: 1;
            text-align: center;
            position: relative;
            &:after, &:before{
                content: '';
                position: absolute;
                width: 50%;
                height: 4px;
                background-color: #e1e5eb;
                top: 23px;
            }
            &:before{
                left: 0;
            }
            &:after{
                left: 50%;
            }

            &:first-child{
                &:before{
                    display: none;
                }
            }
            &:last-child{
                &:after{
                    display: none;
                }
            }

            span:first-child {
                position: relative;
                z-index: 2;
                width: 50px;
                height: 50px;
                display: block;
                text-align: center;
                line-height: 48px;
                background: #f4f5f7;
                margin: 0 auto;
                border-radius: 50%;
                margin-bottom: 10px;
                border: 1px #e1e5eb solid;
                font-weight: bold;
                font-size: 18px;
            }

            &.active {
                &:before, &:after{
                    background-color: #007bff;
                }
                span:first-child{
                    background: #007bff;
                    border-color: #007bff;
                    color: white;
                }
            }

            span:nth-child(2) {
                max-width: 200px;
                display: table;
                margin: 0 auto;
                border-radius: 10px;
                padding: 4px 10px;
                /*font-size: 12px;*/
            }
        }
    }

    td.is-loading {
        opacity: .5;
    }

    .btn.disabled{
        pointer-events: none;
        background: #cccccc;
        opacity: 0.5;
        border-color: #cccccc;
    }
</style>
